import AcceptModal from './AcceptModal';

export default AcceptModal;
